export default __webpack_public_path__ + "static/media/Audio-Number-12.0620bf92.mp3";